import { React } from 'Imports';
import { faGrid3, faList } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ToggleButton, ToggleButtonGroup } from 'MaterialUIComponents';
import { isEncompass } from '$Utilities/integrationPlatform';
import { Box } from '@mui/material';
import classNames from 'classnames';

interface IViewModeToggleButtonProps {
    handleEventLayoutChange: (e: any, value: 'tile' | 'list') => void;
    viewType?: 'tile' | 'list';
}

const styles = require('$Components/FilterComponents/Buttons/ViewModeToggleButton.scss') as {
    toggleButtonGroup: string;
    toggleButtonGroupEncompass: string;
    toggleButtonGroupGeotab: string;
    toggleButton: string;
    toggleButtonEncompass: string;
    toggleButtonGeotab: string;
    activeToggleGeotab: string;
    activeToggleEncompass: string;
    inactiveToggleGeotab: string;
    inactiveToggleEncompass: string;
};

export const ViewModeToggleButton = (props: IViewModeToggleButtonProps) => {
    const { viewType: videoEventViewType, handleEventLayoutChange } = props;

    return (
        <ToggleButtonGroup
            exclusive={true}
            className={classNames(
                styles.toggleButtonGroup,
                isEncompass ? styles.toggleButtonGroupEncompass : styles.toggleButtonGroupGeotab,
            )}
            value={videoEventViewType}
            onChange={(e, value) => handleEventLayoutChange(e, value)}
        >
            <ToggleButton
                value="tile"
                title="Grid View"
                className={classNames(
                    styles.toggleButton,
                    isEncompass ? styles.toggleButtonEncompass : styles.toggleButtonGeotab,
                    videoEventViewType === 'tile'
                        ? isEncompass
                            ? styles.activeToggleEncompass
                            : styles.activeToggleGeotab
                        : isEncompass
                          ? styles.inactiveToggleEncompass
                          : styles.inactiveToggleGeotab,
                )}
            >
                <FontAwesomeIcon icon={faGrid3} size={isEncompass ? 'xs' : 'lg'} />
                <Box>Grid</Box>
            </ToggleButton>
            <ToggleButton
                value="list"
                title="List View"
                className={classNames(
                    styles.toggleButton,
                    isEncompass ? styles.toggleButtonEncompass : styles.toggleButtonGeotab,
                    videoEventViewType === 'list'
                        ? isEncompass
                            ? styles.activeToggleEncompass
                            : styles.activeToggleGeotab
                        : isEncompass
                          ? styles.inactiveToggleEncompass
                          : styles.inactiveToggleGeotab,
                )}
            >
                <FontAwesomeIcon icon={faList} size={isEncompass ? 'xs' : 'lg'} />
                <Box>List</Box>
            </ToggleButton>
        </ToggleButtonGroup>
    );
};
